"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markdownFromSections = exports.sectionsFromMarkdown = exports.markdownFromBlocks = exports.blocksFromMarkdown = void 0;

var blocksFromMarkdown = function blocksFromMarkdown(_ref) {
  var markdown = _ref.markdown;
  return markdown.replace(/<br>/gi, '\n').split(/\n\n/g);
};

exports.blocksFromMarkdown = blocksFromMarkdown;

var markdownFromBlocks = function markdownFromBlocks(_ref2) {
  var blocks = _ref2.blocks;
  return blocks.join("\n\n");
};

exports.markdownFromBlocks = markdownFromBlocks;

var sectionsFromMarkdown = function sectionsFromMarkdown(_ref3) {
  var markdown = _ref3.markdown;
  var sections = [];
  var section = [];
  var blocks = markdown.replace(/<br>/gi, '\n').split(/\n\n/g);
  blocks.forEach(function (block) {
    var headingRegex = /^\s?#+/;
    var heading = headingRegex.test(block);

    if (section.length > 0 && heading) {
      sections.push(section);
      section = [];
    }

    section.push(block);
  }); // don't leave a dangling section

  if (section !== []) {
    sections.push(section);
    section = [];
  }

  sections = sections.map(function (blocks) {
    return blocks.join("\n\n");
  });
  return sections;
};

exports.sectionsFromMarkdown = sectionsFromMarkdown;

var markdownFromSections = function markdownFromSections(_ref4) {
  var sections = _ref4.sections;
  return sections.join("\n\n");
};

exports.markdownFromSections = markdownFromSections;